import angular from 'angular';
import { MeurhEscalaSchedulerService } from '../escala.scheduler.service';
import { MeurhEscalaSchedulerColaboradoresService } from '../escala.scheduler.colaboradores.service';
import { ListagemService } from '../../../../shared/services/listagem.service';
import { SchedulerStatic } from '../../../../shared/components/dhtmlx-scheduler/dhtmlxscheduler';
import { ITrabalhador } from '../../../Trabalhadores/models/trabalhador.model';
import { IFiltroListagemEscala } from '../models/escala.filtros.model';
import { Empresa, Estabelecimento } from '../../../../core/usuario/models/usuario-model';

interface IOpcaoFiltro {
    nome: string;
    [id: string]: string;
}

const TIPO_HORARIO_ESCALA = 6;

export class MeurhEscalaFiltrosController {

    static $inject = [
        '$scope',
        '$rootScope',
        'MeurhEscalaSchedulerService',
        'MeurhEscalaSchedulerColaboradoresService',
        'ListagemService'
    ];

    public schedulerEventos: SchedulerStatic; // instancia do calendario
    public colaboradores: ITrabalhador[];
    public filtros: IFiltroListagemEscala = {
        colaborador: {
            nome: 'Colaboradores',
            valor: []
        },
        situacao: {
            nome: 'Situação do colaborador',
            valor: ''
        },
        tipo: {
            nome: 'Tipo de colaborador',
            valor: null
        },
        departamento: {
            nome: 'Departamentos',
            valor: null
        },
        cargo: {
            nome: 'Cargos',
            valor: null
        },
        lotacao: {
            nome: 'Lotações',
            valor: null
        },
        horario: {
            nome: 'Horários',
            valor: null
        },
        grupodeponto: {
            nome: 'Grupos de ponto',
            valor: null
        },
        tipohorario: {
            nome: 'Tipo de horário',
            valor: false
        }
    };

    public filtrosVisibilidade: { empresa: string, estabelecimento: string };
    // opções dos filtros tiradas dos colaboradores já carregados no calendário, sem requisição
    public opcoesFiltros: {
        departamentos: IOpcaoFiltro[],
        cargos: IOpcaoFiltro[],
        lotacoes: IOpcaoFiltro[],
        grupos: IOpcaoFiltro[],
        horarios: IOpcaoFiltro[],
    } = { departamentos: [], cargos: [], lotacoes: [], grupos: [], horarios: [] };
    public empresas: Empresa[];
    public estabelecimentos: Estabelecimento[];
    public listagemPermissao: string[] = ['visualizar_calendario'];
    public permissaoGrupoEmpresarial = false;

    constructor (
		public $scope: angular.IScope,
        public $rootScope: angular.IRootScopeService & {
            liberadoTela: (arg: string) => boolean,
            temPermissaoGrupoEmpresarial: (permissoes: string[], grupo: string) => boolean,
            session: any,
            nsjGlobals: any
        },
        public MeurhEscalaSchedulerService: MeurhEscalaSchedulerService,
        public MeurhEscalaSchedulerColaboradoresService: MeurhEscalaSchedulerColaboradoresService,
        public ListagemService: ListagemService,
	) {
        this.permissaoGrupoEmpresarial = $rootScope.temPermissaoGrupoEmpresarial(
            this.listagemPermissao,
            $rootScope.nsjGlobals.a.grupoempresarial
        );

        this.MeurhEscalaSchedulerColaboradoresService.filtros = this.filtros;

        $scope.$on('update_filtro_listagem_escala', () => {
            this.montaOpcoesFiltros();
            this.filtraListagem();
        });

        // verifica filtro
        $scope.$watch('$ctrl.filtros', (newValues: IFiltroListagemEscala[], oldValues: IFiltroListagemEscala[]) => {
            if (newValues !== oldValues) {
                this.MeurhEscalaSchedulerColaboradoresService.filtros = this.filtros;
                this.filtraListagem();
			}
        }, true);

        $scope.$watch('$ctrl.filtros.tipohorario.valor', (newValues: boolean | null, oldValues: boolean | null) => {
            if (newValues !== oldValues) {
                this.montaOpcoesFiltros();
			}
        }, true);
    }

    $onInit() {
        this.montaListagemVisibilidade();
    }

    montaListagemVisibilidade() {
        this.empresas = this.ListagemService.montaEmpresas(this.$rootScope.nsjGlobals.a.grupoempresarial, this.listagemPermissao);
        this.estabelecimentos = this.ListagemService.montaEstabelecimentos(this.filtrosVisibilidade.empresa, this.empresas, this.listagemPermissao);
    }

    mudaEstabelecimentos() {
        this.estabelecimentos = this.filtrosVisibilidade.empresa ? this.ListagemService.montaEstabelecimentos(this.filtrosVisibilidade.empresa, this.empresas, this.listagemPermissao) : [];
        this.filtrosVisibilidade.estabelecimento = '';
        this.filtraEmpresaEstabelecimento();
    }

    filtraEmpresaEstabelecimento() {
        this.limpaFiltros();
        // as opções dos filtros são refeitas quando os colaboradores da nova visibilidade forem carregados
        this.$rootScope.$broadcast('colaboradores_refresh');
    }

    limpaFiltros() {
        Object.keys(this.filtros).forEach((key) => {
            Array.isArray(this.filtros[key].valor) ? this.filtros[key].valor = [] : this.filtros[key].valor = null;
        });
    }

    filtraListagem() {
        this.MeurhEscalaSchedulerColaboradoresService.currentPage = 1;
        this.MeurhEscalaSchedulerService.atualizaListagem(this.schedulerEventos);
	}

    private montaOpcoesFiltros() {
        const colaboradores = this.MeurhEscalaSchedulerColaboradoresService.colaboradores.map((colaborador) => colaborador.colaboradorObj);

        let horarios = colaboradores.map((colaborador) => colaborador.horario);
        if (this.filtros.tipohorario.valor) {
            // horario.tipo vem na projeção do backend (projecao=calendario de trabalhadores/sempaginacao)
            horarios = horarios.filter((horario) => Number(horario?.tipo) === TIPO_HORARIO_ESCALA);
        }

        this.opcoesFiltros = {
            departamentos: this.opcoesUnicas(colaboradores.map((c) => c.departamentoobj), 'departamento', (d) => d.nome),
            cargos: this.opcoesUnicas(colaboradores.map((c) => ({ cargo: c.cargoobj?.cargo, nome: c.cargo })), 'cargo', (c) => c.nome),
            lotacoes: this.opcoesUnicas(colaboradores.map((c) => c.lotacaoobj), 'lotacao', (l) => l.nome),
            grupos: this.opcoesUnicas(colaboradores.map((c) => c.grupoobj), 'grupo', (g) => g.nome),
            horarios: this.opcoesUnicas(horarios, 'horario', (h) => h.nome),
        };
    }

    private opcoesUnicas(itens: any[], chave: string, nome: (item: any) => string): IOpcaoFiltro[] {
        const opcoes = new Map<string, IOpcaoFiltro>();
        itens.forEach((item) => {
            const id = item?.[chave];
            if (id && !opcoes.has(id)) {
                opcoes.set(id, { [chave]: id, nome: nome(item) ?? '' });
            }
        });
        return Array.from(opcoes.values()).sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'));
    }
}
